var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-tip"},[_c('img',{staticClass:"not-tip-image",attrs:{"src":"https://xcx-1257793586.cos.ap-beijing.myqcloud.com/linli/images/member/coupon/is-not.png","mode":"widthFix"}}),_c('span',{staticClass:"not-tip-message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }